// ** Redux
import { createListenerMiddleware } from "@reduxjs/toolkit";

// ** Third Party Components
import cookie from "js-cookie";

// ** Actions
import { closeAuthModal, logout } from "store/modules/global-common.slice";
import { setSearchSex } from "store/modules/shared-filters.slice";
import { login } from "../modules/auth/actions/login.action";
import { getUser } from "../modules/global-user/actions/get-user.action";

// ** Configuration
import config from "configuration";

// ############################################################

export const userListenerMiddleware = createListenerMiddleware();

userListenerMiddleware.startListening({
	actionCreator: login.fulfilled,
	effect: async (action, listenerApi) => {
		const isTokenExists = action.payload.isTokenExists;

		if (isTokenExists) {
			const searchSexObject = action.payload.result.search_sex;
			const searchSexArray = searchSexObject
				? Object.keys(searchSexObject).filter(
						(key) => searchSexObject[key] === true,
					)
				: [];

			listenerApi.dispatch(closeAuthModal());
			listenerApi.dispatch(getUser());
			listenerApi.dispatch(setSearchSex(searchSexArray));
		}
	},
});

// ** Logout listener - handles side effects
userListenerMiddleware.startListening({
	actionCreator: logout,
	effect: async () => {
		const cookieName = config.auth.cookieName;

		// Remove host-only cookie (podstawowe usunięcie)
		cookie.remove(cookieName, { path: "/" });

		// Remove cookie bez żadnych opcji (fallback)
		cookie.remove(cookieName);

		// Remove domain cookie if configured
		if (config.cookieDomain) {
			// Usuń z domeną - różne warianty
			cookie.remove(cookieName, {
				domain: config.cookieDomain,
			});
			cookie.remove(cookieName, {
				domain: config.cookieDomain,
				path: "/",
			});

			// Usuń z domeną i secure (dla HTTPS)
			cookie.remove(cookieName, {
				domain: config.cookieDomain,
				path: "/",
				secure: true,
			});
			cookie.remove(cookieName, {
				domain: config.cookieDomain,
				path: "/",
				secure: false,
			});
		}

		// Dodatkowe usunięcie z opcjami secure dla środowisk HTTPS/HTTP
		cookie.remove(cookieName, { path: "/", secure: true });
		cookie.remove(cookieName, { path: "/", secure: false });

		// Usuń z sameSite opcjami (różne warianty)
		cookie.remove(cookieName, { path: "/", sameSite: "lax" });
		cookie.remove(cookieName, { path: "/", sameSite: "strict" });
		cookie.remove(cookieName, {
			path: "/",
			sameSite: "none",
			secure: true,
		});
	},
});

// ############################################################
